import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { FabricProcessingFabric } from '../../../models';
import { TmsWebBaseEditCreateService } from '../../base';

@Injectable({
  providedIn: 'root',
})
export class FabricProcessingFabricService extends TmsWebBaseEditCreateService<
  FabricProcessingFabric,
  FabricProcessingFabric
> {
  constructor() {
    super('FabricProcessingFabric', $localize`Fabric Processing`);
  }

  getForProduct(id: string): Observable<FabricProcessingFabric[]> {
    return this.httpService.get<FabricProcessingFabric[]>(`${this.apiUrl}/Product/${id}`);
  }
}
